import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { EnigmeCompleteDTO } from "../models/enigmeCompleteDTO.model";
import { Router } from "@angular/router";
import { EnigmesFetchedDTO } from "../models/enigmesFetchedDTO.model";

@Injectable({
  providedIn: "root",
})
export class EnigmesService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
  ) {}

  /**
   * Récupération de la liste de toutes les enigmes
   */
  getAllEnigmes(): Observable<EnigmesFetchedDTO> {
    return this.httpClient.get<EnigmesFetchedDTO>(
      environment.baseUrl + "/enigmes/ctf",
    );
  }

  /**
   * Récupération des détails d'une énigme
   * @param id
   */
  getEnigmeById(id: number): Observable<EnigmeCompleteDTO | undefined> {
    return this.httpClient
      .get<EnigmeCompleteDTO>(environment.baseUrl + "/enigmes/" + id)
      .pipe(
        catchError((err) => {
          this.router.navigate(["/ctf"]);
          return of(undefined);
        }),
      );
  }

  /**
   * Validation d'une réponse, vérification de la validité auprès du backend
   * @param id
   * @param answerForm
   */
  addTimeGetAnswer(
    id: number,
    answerForm: { answer: string },
  ): Observable<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.httpClient.post<any>(
      environment.baseUrl + "/enigmes/" + id,
      answerForm,
      httpOptions,
    );
  }

  /**
   * Demande de démarrage d'une énigme
   * @param id
   */
  beginEnigme(id: number): Observable<Date> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.httpClient.post<Date>(
      environment.baseUrl + "/enigmes/" + id + "/begin",
      httpOptions,
    );
  }
}
